import type { SVGProps } from 'react';

export const Replace = (props: SVGProps<any>) => (
  <svg
    height="16px"
    version="1.1"
    viewBox="0 0 16 16"
    width="16px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'replace-icon'}</title>
    <g
      fill="none"
      fillRule="evenodd"
      id="replace-icon"
      stroke={props.stroke ? props.stroke : '#8C8C8C'}
      strokeWidth="1"
    >
      <g
        id="Group-6"
        stroke={props.stroke ? props.stroke : '#8C8C8C'}
        strokeLinecap="round"
        transform="translate(11.5312, 2.8911) rotate(-90) translate(-11.5312, -2.8911)translate(8.4401, -0.4262)"
      >
        <g
          id="Group-5"
          strokeLinejoin="round"
          transform="translate(4.5521, 1.1563) rotate(-86) translate(-4.5521, -1.1563)translate(3.5021, -0.4044)"
        >
          <polyline
            id="Path-3"
            points="0.102205356 0.0624650981 1.99779464 1.56073659 0.102205356 3.05900809"
            transform="translate(1.05, 1.5607) rotate(-4) translate(-1.05, -1.5607)"
          ></polyline>
        </g>
        <path
          d="M4.56575667,1.15631373 C4.7852374,4.48964706 2.79216757,6.63473593 0,6.63473593"
          id="Path-5"
        ></path>
      </g>
      <g
        id="Group-6"
        stroke={props.stroke ? props.stroke : '#8C8C8C'}
        strokeLinecap="round"
        transform="translate(3.4134, 11.8911) scale(-1, -1) rotate(-90) translate(-3.4134, -11.8911)translate(0.3222, 8.5738)"
      >
        <g
          id="Group-5"
          strokeLinejoin="round"
          transform="translate(4.5521, 1.1563) rotate(-86) translate(-4.5521, -1.1563)translate(3.5021, -0.4044)"
        >
          <polyline
            id="Path-3"
            points="0.102205356 0.0624650981 1.99779464 1.56073659 0.102205356 3.05900809"
            transform="translate(1.05, 1.5607) rotate(-4) translate(-1.05, -1.5607)"
          ></polyline>
        </g>
        <path
          d="M4.56575667,1.15631373 C4.7852374,4.48964706 2.79216757,6.63473593 0,6.63473593"
          id="Path-5"
        ></path>
      </g>
      <path
        d="M9.69943221,8.74411978 L13.725861,8.74411978 C14.2708477,8.74411978 14.7126466,9.19183503 14.7126466,9.74411978 L14.7126466,13.7441198 C14.7126466,14.2964045 14.2708477,14.7441198 13.725861,14.7441198 L9.69943221,14.7441198 C9.15444556,14.7441198 8.71264659,14.2964045 8.71264659,13.7441198 L8.71264659,9.74411978 C8.71264659,9.19183503 9.15444556,8.74411978 9.69943221,8.74411978 Z"
        id="Path-2"
        stroke={props.stroke ? props.stroke : '#8C8C8C'}
        strokeWidth="1.2"
      ></path>
      <path
        d="M1.26678563,0 L5.29321441,0 C5.83820108,0 6.28,0.447715248 6.28,1 L6.28,5 C6.28,5.5522847 5.83820108,6 5.29321441,6 L1.26678563,6 C0.721798973,6 0.28,5.5522847 0.28,5 L0.28,1 C0.28,0.447715248 0.721798973,0 1.26678563,0 Z"
        id="Path-2"
        stroke={props.stroke ? props.stroke : '#8C8C8C'}
        strokeWidth="1.2"
      ></path>
    </g>
  </svg>
);
